import React from 'react'
import ContactUsBig from './SpecificDevice/Big/ContactUs'
export default function ContactUs() {
    return (
        <div>
            <ContactUsBig/>
        </div>
    )
}
